import i18n from "../../shared/i18n";
import { $totalCost } from "../../store/selected/shared";
import { AppConfig } from "../../config";
import { isPresent } from "../../utils";

export const validateCheckoutStep = async (): Promise<boolean> => {
  const totalCost = $totalCost.getState();
  const total = totalCost.getAmount() / 100;
  console.log(
    total,
    isPresent(AppConfig.restrictPaymentSize.max) &&
      total > AppConfig.restrictPaymentSize.max
  );

  if (
    isPresent(AppConfig.restrictPaymentSize.min) &&
    total < AppConfig.restrictPaymentSize.min
  ) {
    alert(i18n.t("restrictPaymentSize.min", { v: totalCost.toFormat() }));
    return false;
  }

  if (
    isPresent(AppConfig.restrictPaymentSize.max) &&
    total > AppConfig.restrictPaymentSize.max
  ) {
    alert(i18n.t("restrictPaymentSize.max"));
    return false;
  }

  return true;
};
